import { useRutilusQuery } from '@graphql/client/useRutilusQuery';
import { getTrashCollections } from '@graphql/queries/rutilus/MillionPoundChallenge';

export const TRASH_COLLECTIONS_PAGE_SIZE = 20;

interface IOptions {
  skip?: boolean;
}

export const useTrashCollections = ({ skip }: IOptions = {}) =>
  useRutilusQuery(getTrashCollections, {
    variables: { first: TRASH_COLLECTIONS_PAGE_SIZE },
    skip,
    // cache-and-network on every mount so the campaign home (collectors carousel,
    // total weight) and the Feed list pick up newly-logged entries without a full
    // reload. nextFetchPolicy keeps fetchMore pagination cache-driven.
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });
